import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcDatepicker } from '@one/react';

export type PocDatepickerProps = ComponentPropsWithoutRef<typeof OwcDatepicker>;

export const PocDatepicker = forwardRef<ElementRef<typeof OwcDatepicker>, PocDatepickerProps>((props, ref) => (
    <OwcDatepicker ref={ref} {...props} />
));

PocDatepicker.displayName = 'PocDatepicker';
